import { clearDamageListTable2 } from 'components/DamageTable2/utils';

/**
 * Teardown callbacks that clear persisted, per-customer table state (sort / filter /
 * pagination, saved views, etc.). These run at the app's global teardown points — when the
 * active customer changes (via the `/reset` route) and on logout — so persisted table state
 * does not leak between orgs.
 *
 * To opt a new table into this behavior, add its own `clearXxx` teardown to this list. The
 * * global teardown paths (Reset, logout) call {@link clearAllPersistedTableState} and do not
 * need to change per table.
 */
const TABLE_STATE_TEARDOWNS: Array<() => void> = [clearDamageListTable2];

export const clearAllPersistedTableState = () => {
  TABLE_STATE_TEARDOWNS.forEach(teardown => teardown());
};
